export default "__VITE_ASSET__QZcYGWtN__"